<div class="relative border-round-2xl p-3 md:p-4 mt-2 main-color">
    <p-button
        [text]="true"
        (click)="dismiss()"
        class="absolute top-0 right-0 m-2"
        [attr.aria-label]="'Dismiss quick start banner'">
        <span class="close-icon-color">
            <i class="pi pi-times"></i>
        </span>
    </p-button>

    <div class="flex flex-column mb-3 gap-2">
        <h2 class="m-0">Quick Start</h2>
        <p class="m-0"
            >Get familiar with how everything works by testing out a few key
            actions.</p
        >
    </div>

    <!-- Desktop / tablet -->
    <div class=" overflow-x-auto flex flex-row gap-3 align-items-center">
        <ng-container *ngFor="let quickStartElement of quickStartElements">
            <div
                class="border-round-xl p-4 flex flex-column gap-2 h-13rem w-13rem max-w-full md:p-3 xl:h-11rem align-items-start justify-content-start flex-1 cursor-pointer"
                style="background-color: var(--quick-start-card-bg-color);"
                (click)="quickStartElement.onClick()"
                tabindex="0"
                role="button"
                [attr.aria-label]="quickStartElement.title">
                <img
                    alt=""
                    class="icon-color m-0 mb-2"
                    height="32"
                    loading="lazy"
                    [src]="quickStartElement.icon"
                    width="32" />
                <h3
                    class="m-0 white-space-nowrap"
                    >{{ quickStartElement.title }}</h3
                >
                <p class="text-sm flex-1 m-0">
                    {{ quickStartElement.body }}
                </p>
            </div>
        </ng-container>
    </div>
</div>
